import type { HblPromo } from '@/utils/types'

export function hblMapPromo (promo: any): HblPromo {
    return {
        id: promo?.extensions?.promotion?.id,
        title: promo?.translated?.customFields?.lg_promobar_title,
        description: promo?.translated?.customFields?.lg_promobar_description,
        code: promo?.extensions?.promotion?.code,
        validFrom: promo.extensions?.promotion?.validFrom,
        validUntil: promo.extensions?.promotion?.validUntil,
    }
}
